export const CATERING_PT_BR = {
	title: "Catering",
	description:
		"Gerencie o catering dos seus eventos, receba propostas, envie orçamentos e monitore tudo em um lugar.",
};

export type CateringTranslations = typeof CATERING_PT_BR;
